module.exports = __webpack_public_path__ + "img/lock-icon.78410f88.svg";